import {
	IMfaSessionIssue,
	TMfaSessionAllIssuesResult
} from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import {
	buildBoundingBox,
	buildElementInfo,
	buildTaskManagerTickets,
	MOBILE_SEVERITY_MAP
} from 'src/common/helpers/MobileQueriesHelper';

import { MfaSessionIssuesQuery } from '../MfaSessionIssues.generated';

const transformIssueToSessionIssue = (
	issue: NonNullable<NonNullable<MfaSessionIssuesQuery['issues']>[0]>
): IMfaSessionIssue => {
	const elementInfo = buildElementInfo(issue);
	const taskManagerSystemTickets = buildTaskManagerTickets(issue);
	const boundingBox = buildBoundingBox(issue);

	return {
		id: issue.issue_id,
		type: issue.type_name,
		severity: MOBILE_SEVERITY_MAP[issue.severity_name],
		scanId: issue.scan_id,
		scanName: issue.scan_name ?? 'Scan 1',
		shortNodeId: issue.elements__index[0] ?? '1',
		elementInfo,
		taskManagerSystemTickets,
		screenshotUrl: issue.screenshot,
		boundingBox,
		viewportWidth: issue.viewport_width,
		viewportHeight: issue.viewport_height
	};
};

export const transformMfaSessionIssuesResults = (
	rawResults: MfaSessionIssuesQuery
): TMfaSessionAllIssuesResult => {
	const rows =
		rawResults.issues?.filter(returnNonNull).map((issue) => transformIssueToSessionIssue(issue)) ??
		[];

	let total = 0;
	if (rawResults.total?.length) {
		total = rawResults.total[0]?.issue_id_count ?? 0;
	}

	let unfilteredTotal = 0;
	if (rawResults.unfiltered_total?.length) {
		unfilteredTotal = rawResults.unfiltered_total[0]?.issue_id_count ?? 0;
	}

	return {
		rows,
		total,
		unfilteredTotal
	};
};
